import { useMutation } from "@apollo/client";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useCallback } from "react";
import { View } from "react-native-ui-lib";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { ExportModalRootParamList } from "../../../../types";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { useSaleContextProvider } from "../../utils";
import { exportSaleJson, MUTATION_EXPORT_SALE } from "../../utils/sale-export";
import { useTranslation } from "../../../../utilities/i18n";

export type ExportOptionsModalScreenProps = NativeStackScreenProps<
  ExportModalRootParamList,
  "ExportOptionsModalScreen"
>;

export const ExportOptionsModalScreen = ({
  navigation,
}: ExportOptionsModalScreenProps) => {
  const { t } = useTranslation("sales");
  const { sale } = useSaleContextProvider();
  const exportSaleJsonFn = exportSaleJson();

  const items = [
    {
      key: "json",
      title: t("action.download_sale_json.label"),
      subTitle: t("action.download_sale_json.description"),
      onPress: () => exportSaleJsonFn(sale.id),
    },
  ];

  return (
    <Page>
      <View>
        <FlatActionList items={items} />
      </View>
    </Page>
  );
};
